import React from "react";
import { Button, Tooltip } from "@material-ui/core";
import { Publish as PublishIcon } from "components/MaterialSymbol/MaterialIcons";

function TextFileReaderUploader({
    accept,
    onUpload = () => {},
    disabled = false,
    disabledMessage = "Please select a catalog first.",
    ...otherProps
}) {
    const fileInputRef = React.useRef(null);

    const handleFileUpload = (event) => {
        const file = event.target.files[0];

        if (file) {
            const reader = new FileReader();

            reader.onload = (e) => {
                const fileData = e.target.result;
                onUpload(fileData);
            };

            reader.readAsText(file);
        }
    };

    const handleClick = () => {
        if (disabled) return;

        const fileInput = fileInputRef.current;
        if (!fileInput) return;

        fileInput.value = "";
        fileInput.click();
    };

    const button = (
        <Button {...otherProps} variant="outlined" size="small" disabled={disabled} onClick={handleClick}>
            {disabled ? "Select Catalog First" : "Upload File"}
            <PublishIcon />
            <input
                ref={fileInputRef}
                hidden
                type="file"
                accept={accept}
                onChange={handleFileUpload}
            />
        </Button>
    );

    if (disabled) {
        return (
            <Tooltip title={disabledMessage} arrow>
                <span>{button}</span>
            </Tooltip>
        );
    }

    return (
        button
    );
}

export default TextFileReaderUploader;
